import * as React from 'react';
import { LessonStep, UserLessonDTO, UserCourseDTO } from "../../common/TrainingTypes";
import "./VideoLesson.scss";
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function VideoLessonComponent(props: { course: UserCourseDTO, lesson: UserLessonDTO, step: LessonStep, stepDone: (state: boolean) => void }) {

    // Immediately allow clicking Next for Video lessons?

    React.useEffect(() => {
        props.stepDone(true);
    }, [props])

	return (
		<div className="card">
			<div className="card-header">
				<h5 className="card-title mb-0">{props.lesson.name} &bull; {props.step.name}</h5>
			</div>
			<div className="card-body">
				<div className="row">
                    <div className={props.step.videoURL ? "col-4" : "col-12"}>
                        <Markdown remarkPlugins={[remarkGfm]} className="markdown">{props.step.content.replaceAll('\n', '  \n')}</Markdown>
					</div>
					{props.step.videoURL ?
						<div className="col-8 video-responsive">
							<iframe className="w-100" style={{ aspectRatio: "16/9" }}
								src={props.step.videoURL + "?autoplay=1"}
								frameBorder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
								title="Embedded youtube"
							/>
						</div> : <></>}
				</div>
			</div>
		</div>
	)
}